import { isAfter, isBefore } from 'date-fns';
import { useCallback, useState } from 'react';
import { MAX_DATE, MIN_DATE } from '../utilities/constants.js';
function clampDate(provisional, min, max) {
    if (isAfter(provisional, max)) {
        return max;
    }
    if (isBefore(provisional, min)) {
        return min;
    }
    return provisional;
}
export function useActiveDate2({ initialActiveDate, min = MIN_DATE, max = MAX_DATE }) {
    const [activeDate, setActiveDateInner] = useState(initialActiveDate);
    const setActiveDate = useCallback((inner) => {
        if (typeof inner === 'function') {
            setActiveDateInner((prevActiveDate) => {
                const provisionalNextDate = inner(prevActiveDate);
                return clampDate(provisionalNextDate, min, max);
            });
        }
        else {
            setActiveDateInner(clampDate(inner, min, max));
        }
    }, [min, max]);
    return [activeDate, setActiveDate];
}
//# sourceMappingURL=use_active_date.js.map